module.exports = __webpack_public_path__ + "ba69771c3f08c0e1657aa7cc99cd6354.fbx";